import { useColorScheme } from "@mui/material/styles";

const useResolvedColorSchemeMode = () => {
  const { mode, systemMode } = useColorScheme();
  return mode === "system" ? systemMode : mode;
};

export default useResolvedColorSchemeMode;
